import styled from 'styled-components';
import InfoIcon from '../../icons/info.svg';
import PorscheCloseIcon from '../../icons/porscheCloseIcon.svg';
import DefaultWarningMessageBox, { type WarningMessageBoxProps } from '../default/WarningMessageBox';

const WarningText = styled(DefaultWarningMessageBox)`
    border: 0;
    border-left: 0.25rem solid #ffe58f;
`;

const WarningMessageBox = (props: Omit<WarningMessageBoxProps, 'icon' | 'closeIcon'>) => (
    <WarningText closeIcon={PorscheCloseIcon} icon={InfoIcon} {...props} />
);

export default WarningMessageBox;
